module.exports = __webpack_public_path__ + "img/s5.0.1.0_202608111507.jpg";